var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-lg modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v("Configure View"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Form:")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.formId,
                            expression: "formId",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.formId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v("All fields (default)"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.forms, function (f) {
                          return _c("option", { domProps: { value: f.Id } }, [
                            _vm._v(_vm._s(f.Name)),
                          ])
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("small", { staticClass: "form-text text-muted" }, [
                      _vm._v(
                        "\n                            You can decide which form you want to open when you edit "
                      ),
                      _c("em", [_vm._v(_vm._s(_vm.alternativesLabel))]),
                      _vm._v(
                        ". \n                            Simply select the form on the drop-down. If you don't like any of the existing forms, why not create one of your own!\n                        "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Color:")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.colorAttributeId,
                            expression: "colorAttributeId",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.colorAttributeId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v("None (default)"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.listAttributes, function (a) {
                          return _c("option", { domProps: { value: a.Id } }, [
                            _vm._v(_vm._s(a.Name)),
                          ])
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("small", { staticClass: "form-text text-muted" }, [
                      _vm._v(
                        "\n                            You can color-code your "
                      ),
                      _c("em", [_vm._v(_vm._s(_vm.alternativesLabel))]),
                      _vm._v(
                        " based on any category-based attribute.\n                            This will help you quickly eyeball your "
                      ),
                      _c("em", [_vm._v(_vm._s(_vm.alternativesLabel))]),
                      _vm._v(
                        " and and get a feel for how many fall into each category.\n                            Simply select which attribute you want to use to color-code your "
                      ),
                      _c("em", [_vm._v(_vm._s(_vm.alternativesLabel))]),
                      _vm._v(" within the Kanban.\n                        "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", [_vm._v("Columns:")]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.columnAttributeId,
                            expression: "columnAttributeId",
                          },
                        ],
                        staticClass: "form-control",
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.columnAttributeId = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { domProps: { value: null } }, [
                          _vm._v("Status (default)"),
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.listAttributes, function (a) {
                          return _c("option", { domProps: { value: a.Id } }, [
                            _vm._v(_vm._s(a.Name)),
                          ])
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("small", { staticClass: "form-text text-muted" }, [
                      _vm._v(
                        "\n                            By default, your Kanban will break "
                      ),
                      _c("em", [_vm._v(_vm._s(_vm.alternativesLabel))]),
                      _vm._v(
                        ' out by status.\n                            This lets you set out the "workflow" of '
                      ),
                      _c("em", [_vm._v(_vm._s(_vm.alternativesLabel))]),
                      _vm._v(", but sometimes you might want to see "),
                      _c("em", [_vm._v(_vm._s(_vm.alternativesLabel))]),
                      _vm._v(
                        " broken out by other factors.\n                            You can select any category-attribute simply by selecting that attribute from this menu... and when you're done, you can come back and change it back to status!\n                        "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { type: "button" },
                      on: { click: _vm.confirm },
                    },
                    [_vm._v("Confirm")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }